import Moment from "moment";
export const dateFormatES = 'DD/MM/YYYY';
export const formatDataTime = (date) => {
    return Moment.parseZone(Moment.parseZone(date, dateFormatES).utc(true).format())
}